import { round } from 'lodash';
import React from 'react';
import {
  DataForDesignDrawingsManifold,
  DataForDesignDrawingsRoom,
} from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { DisplayStyle } from './templates/DisplayStyle';
import { PortOrRoomRow } from './templates/PortOrRoomRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
  displayStyle?: DisplayStyle;
  precision?: 2 | 1;
};
export const HeatOutputRow = ({ manifold, displayStyle = 'PerPort', precision = 2 }: Props) => {
  const getValue = (room: DataForDesignDrawingsRoom) =>
    room.heatLossAndHeatOutput == null
      ? ''
      : round(room.heatLossAndHeatOutput.heatOutputInWattsPerSquareMetre, precision);

  return (
    <PortOrRoomRow name="Heat Output (W/m²;)" manifold={manifold} getValue={getValue} displayStyle={displayStyle} />
  );
};
